import { jsx as l } from "react/jsx-runtime";
const a = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#FE5000",
        d: "M17.316 5.663a77 77 0 0 0-10.615 0A1.39 1.39 0 0 0 5.393 6.93c-.172 2.142-.195 5.35-.037 7.49.052.707.673 1.314 1.512 1.314H9.5v3.246l-2.627-.002c-2.409 0-4.571-1.785-4.758-4.319-.17-2.306-.147-5.682.039-7.99.186-2.312 2.045-4.083 4.314-4.246a80 80 0 0 1 11.08 0c2.27.163 4.13 1.934 4.315 4.247.186 2.307.177 5.683.007 7.99-.187 2.533-2.344 4.326-4.753 4.326l-2.6-.002L9.5 22.229v-3.25l5.018-3.246h2.6c.839 0 1.46-.607 1.511-1.314.158-2.14.167-5.348-.005-7.49a1.39 1.39 0 0 0-1.308-1.266"
      }
    )
  }
);
export {
  a as default
};
